import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import { LineChart } from "../../components";
import { getMonth } from "../../utils";
import { iWindow } from "../../config";
import {
	InsightsContainer,
	DividerSmall,
	Stat,
	LineContainer,
	ChartContainer,
	StatsRow,
	StatItem,
	StatColumn,
	Loader,
	SectionHeader,
	SampleNotice
} from "./styles";

interface iProps {
	appointments: Array<any>;
	windowSize?: iWindow | null;
	loading: boolean;
	isSample: boolean;
}
interface iChartField {
	x: string;
	y: number;
}
interface iData {
	id: any;
	color?: string;
	data: Array<any>;
}
interface iStaff {
	name: string;
	id: string;
	totalAppointments: number;
	appointmentDates: any;
}



export default function Appointments (props: iProps) {
	const chartDataDefault: iData[] = [];
	const [ chartData, setChartData ] = useState(chartDataDefault);
	const [ staffProfiles, setStaffProfiles ] = useState() as any;
	const [ staffNames, setStaffNames ] = useState() as any;
	const [ duration, setDuration ] = useState("all");
	const sampleChartData = JSON.parse(`[{"id":"Rebecca Broadhurst","data":[{"x":"May","y":0,"month":5,"year":2020},{"x":"Jun","y":3,"month":6,"year":2020},{"x":"Jul","y":42,"month":7,"year":2020},{"x":"Aug","y":3,"month":8,"year":2020},{"x":"Sept","y":3,"month":9,"year":2020},{"x":"Oct","y":3,"month":10,"year":2020},{"x":"Nov","y":1,"month":11,"year":2020},{"x":"Dec","y":1,"month":12,"year":2020},{"x":"Jan","y":0,"month":1,"year":2021},{"x":"Feb","y":0,"month":2,"year":2021},{"x":"Mar","y":6,"month":3,"year":2021},{"x":"Apr","y":0,"month":4,"year":2021}]},{"id":"L'Oreal Academy (Melbourne)","data":[{"x":"May","y":0,"month":5,"year":2020},{"x":"Jun","y":0,"month":6,"year":2020},{"x":"Jul","y":15,"month":7,"year":2020},{"x":"Aug","y":0,"month":8,"year":2020},{"x":"Sept","y":0,"month":9,"year":2020},{"x":"Oct","y":0,"month":10,"year":2020},{"x":"Nov","y":0,"month":11,"year":2020},{"x":"Dec","y":0,"month":12,"year":2020},{"x":"Jan","y":0,"month":1,"year":2021},{"x":"Feb","y":0,"month":2,"year":2021},{"x":"Mar","y":0,"month":3,"year":2021},{"x":"Apr","y":0,"month":4,"year":2021}]},{"id":"Susan Bolton","data":[{"x":"May","y":0,"month":5,"year":2020},{"x":"Jun","y":0,"month":6,"year":2020},{"x":"Jul","y":21,"month":7,"year":2020},{"x":"Aug","y":0,"month":8,"year":2020},{"x":"Sept","y":3,"month":9,"year":2020},{"x":"Oct","y":6,"month":10,"year":2020},{"x":"Nov","y":2,"month":11,"year":2020},{"x":"Dec","y":4,"month":12,"year":2020},{"x":"Jan","y":0,"month":1,"year":2021},{"x":"Feb","y":1,"month":2,"year":2021},{"x":"Mar","y":12,"month":3,"year":2021},{"x":"Apr","y":0,"month":4,"year":2021}]},{"id":"L'Oreal Academy (Adelaide)","data":[{"x":"May","y":0,"month":5,"year":2020},{"x":"Jun","y":0,"month":6,"year":2020},{"x":"Jul","y":4,"month":7,"year":2020},{"x":"Aug","y":0,"month":8,"year":2020},{"x":"Sept","y":0,"month":9,"year":2020},{"x":"Oct","y":0,"month":10,"year":2020},{"x":"Nov","y":0,"month":11,"year":2020},{"x":"Dec","y":0,"month":12,"year":2020},{"x":"Jan","y":0,"month":1,"year":2021},{"x":"Feb","y":0,"month":2,"year":2021},{"x":"Mar","y":0,"month":3,"year":2021},{"x":"Apr","y":0,"month":4,"year":2021}]},{"id":"Jo Migliaccio","data":[{"x":"May","y":0,"month":5,"year":2020},{"x":"Jun","y":0,"month":6,"year":2020},{"x":"Jul","y":2,"month":7,"year":2020},{"x":"Aug","y":0,"month":8,"year":2020},{"x":"Sept","y":3,"month":9,"year":2020},{"x":"Oct","y":2,"month":10,"year":2020},{"x":"Nov","y":2,"month":11,"year":2020},{"x":"Dec","y":2,"month":12,"year":2020},{"x":"Jan","y":0,"month":1,"year":2021},{"x":"Feb","y":9,"month":2,"year":2021},{"x":"Mar","y":30,"month":3,"year":2021},{"x":"Apr","y":0,"month":4,"year":2021}]},{"id":"Alison Kent","data":[{"x":"May","y":3,"month":5,"year":2020},{"x":"Jun","y":0,"month":6,"year":2020},{"x":"Jul","y":8,"month":7,"year":2020},{"x":"Aug","y":0,"month":8,"year":2020},{"x":"Sept","y":0,"month":9,"year":2020},{"x":"Oct","y":1,"month":10,"year":2020},{"x":"Nov","y":8,"month":11,"year":2020},{"x":"Dec","y":8,"month":12,"year":2020},{"x":"Jan","y":0,"month":1,"year":2021},{"x":"Feb","y":7,"month":2,"year":2021},{"x":"Mar","y":34,"month":3,"year":2021},{"x":"Apr","y":0,"month":4,"year":2021}]},{"id":"Nick Manfield","data":[{"x":"May","y":0,"month":5,"year":2020},{"x":"Jun","y":0,"month":6,"year":2020},{"x":"Jul","y":2,"month":7,"year":2020},{"x":"Aug","y":1,"month":8,"year":2020},{"x":"Sept","y":1,"month":9,"year":2020},{"x":"Oct","y":3,"month":10,"year":2020},{"x":"Nov","y":5,"month":11,"year":2020},{"x":"Dec","y":4,"month":12,"year":2020},{"x":"Jan","y":0,"month":1,"year":2021},{"x":"Feb","y":2,"month":2,"year":2021},{"x":"Mar","y":13,"month":3,"year":2021},{"x":"Apr","y":2,"month":4,"year":2021}]},{"id":"Kiera Anderson","data":[{"x":"May","y":0,"month":5,"year":2020},{"x":"Jun","y":0,"month":6,"year":2020},{"x":"Jul","y":0,"month":7,"year":2020},{"x":"Aug","y":0,"month":8,"year":2020},{"x":"Sept","y":0,"month":9,"year":2020},{"x":"Oct","y":0,"month":10,"year":2020},{"x":"Nov","y":0,"month":11,"year":2020},{"x":"Dec","y":0,"month":12,"year":2020},{"x":"Jan","y":0,"month":1,"year":2021},{"x":"Feb","y":1,"month":2,"year":2021},{"x":"Mar","y":2,"month":3,"year":2021},{"x":"Apr","y":3,"month":4,"year":2021}]},{"id":"(No Name)","data":[{"x":"May","y":0,"month":5,"year":2020},{"x":"Jun","y":0,"month":6,"year":2020},{"x":"Jul","y":0,"month":7,"year":2020},{"x":"Aug","y":0,"month":8,"year":2020},{"x":"Sept","y":0,"month":9,"year":2020},{"x":"Oct","y":0,"month":10,"year":2020},{"x":"Nov","y":1,"month":11,"year":2020},{"x":"Dec","y":0,"month":12,"year":2020},{"x":"Jan","y":0,"month":1,"year":2021},{"x":"Feb","y":1,"month":2,"year":2021},{"x":"Mar","y":0,"month":3,"year":2021},{"x":"Apr","y":1,"month":4,"year":2021}]}]`);
	const sampleStaffNames = JSON.parse(`["Rebecca Broadhurst","L'Oreal Academy (Melbourne)","Susan Bolton","L'Oreal Academy (Adelaide)","Jo Migliaccio","Alison Kent","Nick Manfield","Kiera Anderson","(No Name)"]`);

	useEffect(
		() => {
			updateStaffProfiles();
		},
		[ props.appointments ]
	);

	useEffect(
		() => {
			staffProfiles && updateChart();
		},
		[ staffProfiles, duration ]
	);

	const XTick = (tick: any) => {
		return (
			<g key={tick.x} transform={`translate(${tick.x},${tick.y + 22})`}>
				<line stroke="rgba(0, 0, 0,0.5)" strokeWidth={1.5} y1={-22} y2={-12} />
				{(tick.tickIndex % 3 === 0 || chartData[0]?.data?.length < 8) && (
					<>
					<text
						textAnchor="middle"
						dominantBaseline="middle"
						style={{
							fill: "#000000",
							fontSize: 10
						}}>
						{tick.value}
					</text>
					<text
						textAnchor="middle"
						dominantBaseline="middle"
						y={18}
						style={{
							fill: "#333",
							fontSize: 10
						}}>
						{(duration === "all" || duration === "year") &&
							calcColTotal(tick.value)}
					</text>
					</>
				)}
			</g>
		);
	};

	const calcColTotal = (value: string) => {
		let total = 0;
		chartData.map(monthData => {
			monthData.data.map(month => {
				if (month.x === value) total += month.y;
			});
		});
		return total;
	};

	const updateStaffProfiles = () => {
		const staffMembers: string[] = [];
		const staff: iStaff[] = [];
		const staffNames: string[] = [];

		props.appointments.map(appointment => {
			/* not yet created so set the staff record */
			if (!staffMembers.includes(appointment.staffId)) {
				staffMembers.push(appointment.staffId);
				/* Only use unique names */
				if (!staffNames.includes(appointment.staffName)) {
					staff.push({
						id: appointment.staffId,
						name: appointment.staffName,
						totalAppointments: 1,
						appointmentDates: [ new Date(appointment.createdAt) ]
					});
					staffNames.push(appointment.staffName);
				}
			} else {
				/* Update the existing staff record */
				for (let s = 0; s < staff.length; s++) {
					if (staff[s].id === appointment.staffId) {
						staff[s].totalAppointments += 1;
						staff[s].appointmentDates.push(new Date(appointment.createdAt));
					}
				}
			}
		});

		setStaffNames(staffNames);
		setStaffProfiles(staff);
		console.log(staff);
	};

	const updateChart = () => {
		const memberData: Array<any> = [];
		// FIND EARLIEST DATE 
		let allAppointmentDates = []
		staffProfiles.map(p => { allAppointmentDates = [].concat(allAppointmentDates,p.appointmentDates)});
		let firstDate = moment(new Date(allAppointmentDates.sort(function(a,b){return a - b})[0]));
		let thisYear = moment().year();

		if (duration === "all" ) {
			staffProfiles.map(profile => {
				const member: iData = {
					id: profile.name,
					data: []
				};
				const today = moment();
				for (let y = firstDate.year(); y <= thisYear; y++) {
					let totalMonths = 12;
					// IF ITS THIS YEAR, DONT GET FUTURE MONTHS
					if (y === thisYear) {
						totalMonths = moment().month() + 1;
					}
					for (let m = 0; m < totalMonths; m++) {
						member.data.push({
							x: (m+1)+"-"+y,
							y: getYearlyMonthlyStat(m, y, profile),
							month: m + 1,
							year: y
						});
					}
				}

				/* SORT MEMBER DATA YEAR, CURRENT MONTH FIRST */
				member.data.sort(function (b, a) {
					if (a.year === b.year) {
						return b.month - a.month;
					}
					return b.year - a.year;
				});

				memberData.push(member);
			});
		} else if (duration === "year") {
			staffProfiles.map(profile => {
				const member: iData = {
					id: profile.name,
					data: []
				};
				const today = moment();
				for (let i = 0; i < 12; i++) {
					member.data.push({
						x: getMonth(i + 1),
						y: getMonthlyStat(i, profile),
						month: i + 1,
						year: i > today.month() ? today.year() - 1 : today.year()
					});
				}

				/* SORT MEMBER DATA YEAR, CURRENT MONTH FIRST */
				member.data.sort(function (b, a) {
					if (a.year === b.year) {
						return b.month - a.month;
					}
					return b.year - a.year;
				});

				memberData.push(member);
			});
		}
		console.log('DATA', memberData)
		setChartData(memberData);
	};

	const getYearlyMonthlyStat = (month: number, year: number, staffMember: iStaff) => {
		let stat = 0;

		staffMember.appointmentDates.map(date => {
			if (date.getMonth() === month && date.getFullYear() === year) stat += 1;
		});

		return stat;
	};

	const getMonthlyStat = (month: number, staffMember: iStaff) => {
		let stat = 0;

		staffMember.appointmentDates.map(date => {
			if (date.getMonth() === month) stat += 1;
		});

		return stat;
	};

	const calcMonthTotal = () => {
		let sales = 0;
		const now = moment();

		props.appointments.map(appointment => {
			const apptDate = moment(new Date(appointment.createdAt));
			if (apptDate.month() === now.month()) {
				sales += 1;
			}
		});

		return sales;
	};

	const indexBy = duration === "all" || duration === "year" ? "MONTH" : "DAY";

	const axisBottom = {
		tickSize: 5,
		tickPadding: 5,
		tickRotation: 0,
		legend:
			duration === "all" || duration === "year"
				? "MONTH"
				: duration === "month" ? "DAY OF THE MONTH" : "DAY OF THE WEEK",
		legendPosition: "middle",
		legendOffset: 54,
		renderTick: XTick
	};

	const axisLeft = {
		tickSize: 5,
		tickPadding: 5,
		tickRotation: 0,
		legend: "NO. OF APPOINTMENTS",
		legendPosition: "middle",
		legendOffset: -40
	};

	const color = { scheme: "nivo" };
	const fontStyle = {
		fontSize: 8,
		fontWeight: "bold",
		textTransform: "uppercase"
	};

	return (
		<InsightsContainer>
			<Grid container>
				<Grid item xs={11}>
					<SectionHeader>
						Client sessions <span>using piiq Pro</span>
					</SectionHeader>
				</Grid>
				{props.isSample && (
					<Grid item xs={11}>
						<SampleNotice>We’ve filled out your dashboard with sample data for now. As soon as you have real data we’ll update it here.</SampleNotice>
					</Grid>
				)}
			</Grid>

			<DividerSmall />

			<StatsRow  style={{ opacity: props.isSample ? '0.5' : '1' }}>
				<StatColumn>

					<StatItem>
						<Typography
							align="left"
							style={{ textTransform: "uppercase", fontSize: "0.5rem" }}>
							<FormattedMessage
								id="dashboard.dashappointment.all_time"
								defaultMessage={`All Time`}
							/>
						</Typography>
						<Stat>{props.isSample ? 100 : props.appointments.length}</Stat>
					</StatItem>
					<StatItem>
						<Typography
							align="left"
							style={{ textTransform: "uppercase", fontSize: "0.5rem" }}>
							<FormattedMessage
								id="dashboard.dashappointment.month_to_date"
								defaultMessage={`Month-To-Date`}
							/>
						</Typography>
						<Stat>{props.isSample ? 100 : calcMonthTotal()}</Stat>
					</StatItem>
					<StatItem>
						<Typography
							align="left"
							style={{ textTransform: "uppercase", fontSize: "0.5rem" }}>
							<FormattedMessage
								id="dashboard.dashappointment.average_per_week"
								defaultMessage={`Average Per Week`}
							/>
						</Typography>
						<Stat>{props.isSample ? 100 : (props.appointments.length / 52).toFixed(1)}</Stat>
					</StatItem>
					<StatItem>
						<Typography
							align="left"
							style={{ textTransform: "uppercase", fontSize: "0.5rem" }}>
							<FormattedMessage
								id="dashboard.dashappointment.average_per_day"
								defaultMessage={`Average Per Day`}
							/>
						</Typography>
						<Stat>{props.isSample ? 100 : (props.appointments.length / 365).toFixed(1)}</Stat>
					</StatItem>

				</StatColumn>
				{props.loading ? (
					<Loader>
						<CircularProgress />
					</Loader>
				) : (
					<ChartContainer>
						<LineContainer>
							{(chartData.length > 0 || props.isSample)  && (
								<LineChart
									data={props.isSample ? sampleChartData : chartData}
									keys={props.isSample ? sampleStaffNames : staffNames}
									indexBy={indexBy}
									axisBottom={axisBottom}
									axisLeft={axisLeft}
									color={color}
									fontStyle={fontStyle}
									xLabel={"MONTH"}
									yLabel={"No. Of APPOINTMENTS"}
									customTooltip={({ slice }) => {
										console.log(slice);
										let total = 0;
										slice.points.map(point => {total += point.data.y})
										let month = getMonth(slice?.points[0].data.month)
										return (
											<div
												style={{
													background: 'white',
													padding: '9px 12px',
													border: '1px solid #ccc',
													fontSize:14, fontFamily: "Helvetica, Arial", textTransform:"none"
												}}
											>
												<div>{month} {slice?.points[0].data.year}</div>
												{slice.points.map(point => (
													<div
														key={point.id}
														style={{
															color: point.serieColor,
															padding: '3px 0',
														}}
													>
														<strong>{point.serieId}</strong> [{point.data.yFormatted}]
													</div>
												))}
												<div><strong>Total</strong> [{total}]</div>
											</div>
										)
									}}
								/>
							)}
						</LineContainer>
					</ChartContainer>
				)}
			</StatsRow>
		</InsightsContainer>
	);
}
